import React, { useState } from "react";

const Translator = () => {
  const [text, setText] = useState("Hello, how are you?");
  const [translated, setTranslated] = useState("");

  const translateText = async (targetLang) => {
    const response = await fetch(
      `https://translation.googleapis.com/language/translate/v2?key=YOUR_API_KEY`,
      {
        method: "POST",
        body: JSON.stringify({
          q: text,
          target: targetLang,
        }),
        headers: { "Content-Type": "application/json" },
      }
    );
    const data = await response.json();
    setTranslated(data.data.translations[0].translatedText);
  };

  return (
    <div>
      <p>Original: {text}</p>
      <p>Translated: {translated}</p>
      <button onClick={() => translateText("sw")}>Translate to Swahili</button>
      <button onClick={() => translateText("fr")}>Translate to French</button>
    </div>
  );
};

export default Translator;